// Smoking and alcohol on the patient record. Four answers rather than a yes/no
// tick: a question nobody put to the patient is not a "no", and an ex-smoker is
// not a non-smoker. Keep in step with the `smoker` / `alcoholic` enums on the
// Patient model.
export const LIFESTYLE_VALUES = ['yes', 'no', 'former', 'unknown'];

// 'unknown' is what an unasked question looks like, so it reads as "not recorded"
// rather than as an answer.
const LABEL_KEYS = {
    yes: 'yes',
    no: 'no',
    former: 'former',
    unknown: 'notRecorded'
};

// Colour carries the clinical weight: a current habit stands out, a past one is
// worth a glance, and "no" should not shout.
const COLORS = {
    yes: 'red',
    former: 'orange',
    no: 'green',
    unknown: 'default'
};

export const lifestyleOptions = (t) => LIFESTYLE_VALUES.map((value) => ({
    value,
    label: t(LABEL_KEYS[value])
}));

export const lifestyleLabel = (t, value) => t(LABEL_KEYS[value] || 'notRecorded');

export const lifestyleColor = (value) => COLORS[value] || COLORS.unknown;
